import React from "react";

import { ReactComponent as TickIcon } from "../../assets/icons/subscription-plans/tick-icon.svg";
import { ReactComponent as PlusIcon } from "../../assets/icons/subscription-plans/plus-icon.svg";
import {
  SUBSCRIPTION_PLAN_MAPPING,
  SUBSCRIPTION_PLAN_BUTTON_NAME,
  CUSTOMER_SUBSCRIPTION_PLAN_TYPE_MAPPING,
} from "../../constants";
import {
  SUBSCRIPTION_PLAN,
  SUBSCRIPTION_PLAN_TYPE,
  SUBSCRIPTION_PLAN_DURATION,
} from "../../system";
import { numberFormatting } from "../../shared/utility";

const getSubscriptionPlanDetails = [
  {
    plan: 2,
    bestFor: "Boutique or solo agents testing the market",
    note: "Free listings help you experience the platform risk-free. Listing limits ensure quality and relevance.",
  },
  {
    plan: 3,
    bestFor: "Growing agencies expanding their international reach",
    note: "This plan gives you more room to grow while keeping your listings curated and focused.",
  },
  {
    plan: 4,
    bestFor: "High-volume agents with large, high-value portfolios",
    note: "Agents with international property listings across multiple countries. Ideal for those seeking maximum exposure.",
  },
];

const SubscriptionCard = ({ plan, isAgent, subscribe, isNotSubscribed }) => {
  const isRecommended = isAgent
    ? plan.plan === SUBSCRIPTION_PLAN.PROFESSIONAL
    : plan.planType === SUBSCRIPTION_PLAN_TYPE.SEASONAL;

  const calculateMonthlyAmount = (plan) => {
    const months = SUBSCRIPTION_PLAN_DURATION[plan.planType];
    return (plan.amount / months).toFixed(2);
  };

  const planDetails = getSubscriptionPlanDetails.find(
    (s) => s.plan === plan.plan
  );

  return (
    <div className={`card ${isAgent ? "agent-card" : ""}`} key={plan.id}>
      <div
        className={`card-header ${
          isRecommended ? "recommended" : "d-none d-md-block"
        }`}
      >
        <h4>{isRecommended && "Recommended"}</h4>
      </div>
      <div className={`card-body ${isRecommended && "recommended"}`}>
        <h1 className="card-title">
          {isAgent
            ? SUBSCRIPTION_PLAN_MAPPING[plan.plan]
            : CUSTOMER_SUBSCRIPTION_PLAN_TYPE_MAPPING[plan.planType]}
        </h1>
        <h1 className="card-amount">${numberFormatting(plan.amount)}</h1>
        <p className="pricing-detail">
          <span>(${calculateMonthlyAmount(plan)} per month)</span>
        </p>
        {isAgent && (
          <p className="description w-100">
            <div className="row text-start ps-2 my-2">
              <div className="col-2">
                <TickIcon className="icon" />
              </div>
              <div className="col-10 px-0">
                {plan.freeListing} free listings
              </div>
            </div>
            <div className="row text-start ps-2 my-2">
              <div className="col-2">
                <PlusIcon className="icon" />
              </div>
              <div className="col-10 px-0">
                Up to {plan.additionalListing} additional listings
              </div>
            </div>
            <div className="row text-start ps-2 my-2">
              <div className="col-2"></div>
              <div className="col-10 px-0">
                (Total: {plan.freeListing + plan.additionalListing})
              </div>
            </div>
            <div className="row text-start ps-2 my-1">
              <div className="col-12">Best For: {planDetails?.bestFor}</div>
            </div>
            <div className="row text-start ps-2 my-1">
              <div className="col-12">Note: {planDetails?.note}</div>
            </div>
          </p>
        )}
        <span className={plan.isAlreadySubscribed ? "button-disabled" : ""}>
          <button
            className="btn btn-outline-primary"
            type="button"
            onClick={() => subscribe(plan.id)}
            disabled={plan.isAlreadySubscribed}
          >
            {plan.isAlreadySubscribed
              ? SUBSCRIPTION_PLAN_BUTTON_NAME.SUBSCRIBED
              : isAgent && isNotSubscribed
              ? SUBSCRIPTION_PLAN_BUTTON_NAME.GET_STARTED
              : !isAgent && isNotSubscribed
              ? SUBSCRIPTION_PLAN_BUTTON_NAME.START_FREE_TRIAL
              : SUBSCRIPTION_PLAN_BUTTON_NAME.UPDATE}
          </button>
        </span>
      </div>
    </div>
  );
};

export default SubscriptionCard;
